import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgEmailActionRemoveBold = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "email-action-remove" }),
		/* @__PURE__ */ _jsx("path", { d: "M17.5,9.5a7.908,7.908,0,0,1,3.151.657A.251.251,0,0,0,21,9.927V1.75a.158.158,0,0,0-.1-.147.16.16,0,0,0-.173.034L12.2,10.164a2.407,2.407,0,0,1-3.4,0L.271,1.637A.159.159,0,0,0,0,1.75v10.5A1.749,1.749,0,0,0,1.75,14h8.413a.252.252,0,0,0,.223-.136A8,8,0,0,1,17.5,9.5Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M9.726,9.236a1.094,1.094,0,0,0,1.547,0L19.748.761a.437.437,0,0,0,.106-.447C19.758.027,19.49,0,19.249,0H1.749c-.24,0-.51.027-.605.314A.441.441,0,0,0,1.25.761Z" }),
		/* @__PURE__ */ _jsx("path", { d: "M17.5,11A6.5,6.5,0,1,0,24,17.5,6.508,6.508,0,0,0,17.5,11Zm-2.651,4.909a.75.75,0,0,1,1.06-1.06l1.414,1.414a.252.252,0,0,0,.354,0l1.414-1.414a.75.75,0,1,1,1.06,1.06l-1.414,1.414a.252.252,0,0,0,0,.354l1.414,1.414a.75.75,0,1,1-1.06,1.06l-1.414-1.414a.252.252,0,0,0-.354,0l-1.414,1.414a.75.75,0,1,1-1.06-1.06l1.414-1.414a.252.252,0,0,0,0-.354Z" })
	]
});
export default SvgEmailActionRemoveBold;
